module.exports = __webpack_public_path__ + "static/media/free-trail.6f608a06.png";